import dynamic from "next/dynamic";

export const DynamicContent052 = dynamic(() => import("./Content052"), {
  suspense: true,
});
